import moment from 'moment'

export const durationToMinutes = (duration: number | string) => {
  return moment.duration(parseFloat(duration.toString()), 'hours').format('HH:mm', { trim: false })
}
